export default __webpack_public_path__ + "static/media/13.535f5a63.jpeg";